// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"050bc7b280e3b2a9f5cc","5338":"3a6022d36b1cee61ddda"}[chunkId] + ".js";
};